<template>
<div class="container">
  <Header />
  <div style="padding-right:1.25rem" class="text-right">
    <div v-if="searchVisibility==false">
      <b-button variant="success" class="my-2 mx-2" v-b-toggle.my-collapse size="sm">検索条件を開く</b-button>
    </div>
    <div v-else>
      <b-button variant="success" class="my-2 mx-2" v-b-toggle.my-collapse size="sm">検索条件を閉じる</b-button>
    </div>
  </div>
  <b-collapse id="my-collapse" v-model="searchVisibility">
    <b-card no-body>
      <b-tabs card>
        <b-tab title="絞り込み" active>
          <b-row>
            <b-col style="padding-left:0px">
              <b-form-group label="名前">
                <b-form-select v-model="column" class="mx-2" :options="aiueOptions" @change="filterChanged"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col style="padding-left:0px">
              <b-form-group label="入学年度">
                <b-form-select v-model="year" class="mx-2" :options="yearOptions" @change="filterChanged"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form>
          </b-form>
          <hr>
          <div v-if="nameListFiltered.length==0">
            <p class="text-center">該当のユーザーは見つかりませんでした。</p>
          </div>
          <div v-else>
            <b-row>
              <b-col cols="4" class="my-2 nameButton" v-for="(idList,index) in nameListFiltered" :key="index">
                <router-link :to="{ name: 'individualRecords',query:{userId:idList.id,userName:idList.name}}">
                  <b-button block variant="outline-info">{{ idList.name }}</b-button>
                </router-link>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="直接検索">
          <div class="row">
            <b-form-input v-model="searchedName" placeholder="東大太郎" list="memberListSuggestion" @update="searchByName(searchedName)" autocomplete="off">
            </b-form-input>
            <datalist id="memberListSuggestion">
              <option v-for="member in suggestMemberList(searchedName)" :key="member">{{member}}</option>
            </datalist>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-collapse>
  <hr>
  <div id="dataArea" v-if="dataAreaVisibility">
    <Profile :userId="selectedUserId" :currentUserId="uid"></Profile>
    <hr>
    <b-row class="pb-2">
    <h5 class="my-auto">{{ selectedName }}さんの練習記録</h5>
    <b-button size="sm" variant="primary" class="ml-auto" @click="showKagetoraRecord()">景虎の記録</b-button>
    </b-row>
    <!--    <b-button class="my-1" variant="success" v-b-toggle.fieldsButtonGroup >表示項目を選択</b-button> b-collapseじゃなくてもよくね？-->
    <div id="fieldsButtonGroup">
      <b-form-group v-slot="{ariaDescribedby}" class="mb-0">
        <b-form-radio-group size="sm" v-model="selectedFieldsValue" :options="fieldsOptions" button-variant="outline-primary" :aria-describedby="ariaDescribedby" @change="fieldsChange" buttons></b-form-radio-group>
      </b-form-group>
    </div>
    <b-table striped bordered hover v-for="(practiceDataArray, index) in dataList" :key="index" :items="practiceDataArray.data" :fields="fields" caption-top>
      <template #table-caption class="text-danger">
        <div v-if="index>0">
          <hr>
        </div>
        {{practiceDataArray.date|unixtimeToDate}}
      </template>
      <template v-slot:[`cell(opponent)`]="data">
        <div class="text-center">
          <div v-if="data.item.opponentId==''">{{data.item.opponent}}
            <font-awesome-icon size="sm" :icon="['fas','user-alt-slash']" />
          </div>
          <div v-else>
            <router-link :to="{ name: 'individualRecords',query:{userId:data.item.opponentId,userName:data.item.opponent}}">{{data.item.opponent}}</router-link>
          </div>
        </div>
      </template>
      <template #cell(comment)="data">
        <div v-if="data.item.comments != undefined" class="text-left">
          {{data.item.comments|showLatestComment|showCommentName}}
          {{data.item.comments|showLatestComment|showCommentUnixtime|unixtimeToDate}}<br>
          {{data.item.comments|showLatestComment|showCommentText}}
        </div>
      </template>
      <template #cell(detailButton)="data">
        <b-button size="sm" variant="success" class="my-1 mx-1" @click="findFocusRecord(data.item.date,data.item.round,data.item.key)">詳細</b-button>
      </template>
    </b-table>
    <div v-if="dataList.length==0">
      <p class="text-center">該当の練習記録は見つかりませんでした。</p>
    </div>
    <b-modal v-bind:id="'edit'" hide-header hide-footer modal-center>
      <Record :record="this.focusRecord" />
    </b-modal>
  </div>
</div>
</template>
<style>
.resetButton {
  margin-right: 0.5rem !important;
  margin-left: auto !important;
}

.row {
  margin-left: 0rem !important;
  margin-right: 0rem !important;
}

.nameButton {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/*PCの場合*/
.pc {
  display: inline !important;
}

.mb {
  display: none !important;
}

@media screen and (max-width: 768px) {

  /*タブレット、スマホの場合*/
  .pc {
    display: none !important;
  }

  .mb {
    display: inline !important;
  }

  .container {
    margin-bottom: 64px;
  }
}

.vdp-datepicker__calendar {
  width: auto !important;
}

.table th, .table td {
  padding: 0.25rem;
  vertical-align: middle;
}

.table td.records-result {
  width: 13%;
}

.table td.records-cardNumber {
  width: 13%;
}

.table td.records-round {
  width: 13%;
}
</style>

<script>
import Header from '../components/Header.vue'
import Record from '../components/Record.vue'
import Profile from '../components/Profile.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import {
  ja
} from 'vuejs-datepicker/dist/locale';
import 'dayjs/locale/ja'
import dayjs from 'dayjs'

export default {
  name: 'individualRecords',
  components: {
    Header,
    Record,
    Profile,
  },
  filters: {
    unixtimeToDate: function(unixtime) {
      return dayjs(unixtime * 1000).format('YYYY/MM/DD');
    },
    unixtimeToPreciseDate: function(unixtime) {
      return dayjs(unixtime * 1000).format('YYYY/MM/DD HH:mm:ss');
    },
    showLatestComment: function(comments) {
      let keys = Object.keys(comments)
      let latestComment = ""
      for(let i=keys.length-1;i>=0;i--){
        let comment = comments[keys[i]];
        if("commentType" in comment){
          if(comment["commentType"]=="public"){
            latestComment = comment
            break;
          }
        }
      }
      return latestComment
    },
    showCommentText: function(comment) {
      if(comment==="") return ""
      else return comment['text']
    },
    showCommentName: function(comment) {
      if(comment==="") return ""
      else return comment['name']+": "
    },
    showCommentUnixtime: function(comment) {
      if(comment==="") return ""
      else return comment['unixtime']
    }
  },
  data() {
    return {
      matchList: [],
      memberList: [],
      memberNameList: [],
      memberKanaList: [],
      searchedName: "",
      result: {
        date: dayjs(new Date()).format('YYYY-MM-DD'),
        player1Name: "",
        player2Name: "",
        player1Result: "",
        player2Result: "",
        cardNumber: "",
      },
      nameList: [
        "これが",
        "表示",
        "されたら",
        "バグです",
        "nameList"
      ],
      nameListFiltered: [
        "これも",
        "表示",
        "されたら",
        "バグです",
        "nameListFiltered"
      ],
      aiueOptions: [
        "指定なし",
        "あ行",
        "か行",
        "さ行",
        "た行",
        "な行",
        "は行",
        "ま行",
        "や行",
        "ら行",
        "わ行",
        "その他",
      ],
      column: "指定なし",
      nameAIUEOptions: {
        "あ行": ["阿波加遼平", "奥田光市"],
        "か行": [],
        "さ行": [],
        "た行": ["田中琢朗"],
        "な行": [],
        "は行": ["藤本一孝", "堀本秋水"],
        "ま行": [],
        "や行": [],
        "ら行": [],
        "わ行": [],
        "その他": [],
      },
      yearOptions: [
        "指定なし",
        2014,
        2015,
        2016,
        2017
      ],
      year: "指定なし",
      nameYearOptions: {
        "2012年": ["岩戸良輔", "奥田光市"],
        "2013年": ["細井將史", "渡邉至穂子"],
        "2014年": ["山嵜利樹", "吉井恵理佳"],
        "2015年": ["藤井みずほ"],
        "2016年": ["江川咲子", "堀本秋水"],
        "2017年": ["田中琢朗"],
        "2018年": [],
        "2019年": [],
        "2020年": [],
      },
      gojuonhyo: {
        "あ行": ["あ", "い", "う", "え", "お"],
        "か行": ["か", "き", "く", "け", "こ", "が", "ぎ", "ぐ", "げ", "ご"],
        "さ行": ["さ", "し", "す", "せ", "そ", "ざ", "じ", "ず", "ぜ", "ぞ"],
        "た行": ["た", "ち", "つ", "て", "と", "だ", "ぢ", "づ", "で", "ど"],
        "な行": ["な", "に", "ぬ", "ね", "の"],
        "は行": ["は", "ひ", "ふ", "へ", "ほ", "ば", "び", "ぶ", "べ", "ぼ", "ぱ", "ぴ", "ぷ", "ぺ", "ぽ"],
        "ま行": ["ま", "み", "む", "め", "も"],
        "や行": ["や", "ゆ", "よ"],
        "ら行": ["ら", "り", "る", "れ", "ろ"],
        "わ行": ["わ"],
        "その他": ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
      },
      dataList: [ //表で出す練習記録一覧。v-forで使いたいので「table用arrayたち」のリストor連想配列
        {
          "date": 1612345678,
          "data": [{
              "round": 2,
              "id": "zxcvbnm",
              "opponent": "てすと1",
              "result": 1,
              "cardNumber": 18
            },
            {
              "round": 3,
              "opponent": "てすと2",
              "result": 0,
              "cardNumber": 3
            }
          ]
        },
        {
          "date": 1623456789,
          "data": [{
              "round": 1,
              "id": "qwertyu",
              "opponent": "東大太郎",
              "result": 0,
              "cardNumber": 22
            },
            {
              "round": 2,
              "id": "asdfghjkl",
              "opponent": "あいうえお",
              "result": 1,
              "cardNumber": 8
            }
          ]
        }
      ],
      searchVisibility: true,
      dataAreaVisibility: false,
      currentQuery: "",
      selectedName: "でふぉると",
      selectedUserId: "",
      selectedFieldsValue: "",
      fieldsOptions: [ //valueはStringか連想配列しかとれないが、tableのfieldsはarrayしか受け付けないため、直接の指定はできない模様…
        {
          text: "○×",
          value: "marubatsu"
        },
        {
          text: "指導内容",
          value: "shidou"
        },
        {
          text: "コメント",
          value: "komento"
        }
      ],
      resultOptions: [{
          value: null,
          text: ''
        },
        {
          value: true,
          text: '勝ち'
        },
        {
          value: false,
          text: '負け'
        },
      ],
      userStatus: {},
      authorized: false,
      form: {
        name: "",
      },
      ja: ja,
      recordList: [
        /*      {date:"2020/12/30",
               round:"2",
               player1Name: "堀本秋水",
               player1Uid: "asdfg",
               player2Name: "奥田光市",
               player2Uid: "qwert",
               player1Result: false,
               player2Result: true,
               cardNumber: "14",
             }*/
      ],
      fields: [{
          key: "round",
          label: "回戦",
          thClass: "text-center",
          tdClass: "text-center records-round"
        },
        {
          key: "opponent",
          label: "対戦相手",
          thClass: "text-center",
          tdClass: "text-center records-name"
        },
        {
          key: "result",
          label: "勝敗",
          formatter: "numberToSymbol",
          thClass: "text-center",
          tdClass: "text-center records-result"
        },
        {
          key: "cardNumber",
          label: "枚数",
          thClass: "text-center",
          tdClass: "text-center records-cardNumber"
        },
        {
          key: "detailButton",
          label: "",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      focusRecord: {},
      user: firebase.auth().currentUser,
      uid: firebase.auth().currentUser.uid,
      currentPage: 1,
      KAGETORA_URL: "",
      KAGETORA_URL_BASE: "https://kagetora.bushidoo.com/result_record#show/",
    }
  },
  watch: {
    '$route'(to) {
      console.log(to.query.userId);
      if (to.query.userId) {
        this.nameSelected(to.query.userId, to.query.userName);
        this.selectedUserId = to.query.userId
        this.searchOff();
      }
    },
    selectedUserId: function() {
      this.createKagetoraURL()
    }
  },
  beforeCreate() {},
  created: function() {
    console.log(this.$route.query)
    this.database = firebase.database();
    this.uid = firebase.auth().currentUser.uid;
    this.search();
    this.searchVisibility = true;
    this.dataAreaVisibility = false;
    /*    firebase.database().ref('users/').on("value", snapShot => {
          if (snapShot) {
            _this.memberNameList = [];
            _this.memberKanaList = [];
            snapShot.forEach((data) => {
              var user = data.val();
              user["uid"] = data.key;
              _this.memberNameList.push(user["name"]);
              _this.memberKanaList.push(user["kana"]);
              _this.memberList.push({"name": user["name"],"kana": user["kana"],"uid": user["uid"]});
            })
          }
        })*/

    if (this.$route.query.userId) {
      this.searchVisibility = false
      this.nameSelected(this.$route.query.userId, this.$route.query.userName);
      this.selectedUserId = this.$route.query.userId
      // this.searchOff();
    }
  },
  beforeDestroy: function() {
    this.database.ref("users").off();
    if (this.currentQuery != "") {
      this.currentQuery.off();
      console.log("ページ遷移時に破棄しました");
    }
  },
  methods: {
    search() {
      var nameQuery = this.database.ref("users").orderByChild("kana");
      var _this = this; //foreach中でのthisはwindowではないっぽい
      nameQuery.on('value', function(snapshot) {
        _this.memberNameList = [];
        _this.nameList = []; //リセット
        _this.yearOptions = ["指定なし"]; //リセット
        var yearSet = new Set(); //userが1人以上いる入学年度を表示したいが、重複を除くためsetにいったん格納
        snapshot.forEach(function(child) {
          if (child.val()["authorized"] == false) return; //authorizedされていないユーザーを除外
          _this.memberNameList.push(child.val()["name"]);
          var nameId = {}; //名前、かな、かなの最初の文字、入学年度、idを持った連想配列を作る
          nameId["id"] = child.key;
          nameId["name"] = child.val()["name"];
          nameId["kana"] = child.val()["kana"];
          nameId["firstLetter"] = child.val()["kana"].charAt();
          nameId["enterYear"] = child.val()["enterYear"];
          _this.nameList.push(nameId);
          yearSet.add(child.val()["enterYear"] + "年"); //入学年度のsetに入学年度を追加
        });
        _this.nameListFiltered = _this.nameList; //初期表示はとりあえず全てのuser
        _this.yearOptions = _this.yearOptions.concat(Array.from(yearSet)); //入学年度のsetをyearOptionsに追加
        _this.yearOptions = _this.yearOptions.sort(function(a, b) { //setは追加順のため、入学年度降順にソート。"全ての〜"もいい感じにソートされる
          if (b > a) {
            return 1;
          } else {
            return -1;
          }
        });
      });
    },
    filterChanged() { //FizzBuzzみたい
      var selectedFirstLetterList = this.gojuonhyo[this.column];
      var selectedEnterYear = this.year.slice(0, -1);
      if (this.column != "指定なし" && this.year != "指定なし") { //名前と入学年度の二重検索
        this.nameListFiltered = this.nameList.filter(id => selectedFirstLetterList.includes(id["firstLetter"]) && id["enterYear"] == selectedEnterYear);
      } else if (this.column != "指定なし") { //名前のみで検索
        this.nameListFiltered = this.nameList.filter(id => selectedFirstLetterList.includes(id["firstLetter"]));
      } else if (this.year != "指定なし") { //入学年度のみで検索
        this.nameListFiltered = this.nameList.filter(id => id["enterYear"] == selectedEnterYear);
      } else { //どちらも全て。一応。
        this.nameListFiltered = this.nameList;
      }
    },
    filterReset() {
      this.column = "指定なし";
      this.year = "指定なし";
      this.nameListFiltered = this.nameList; //onchangeはトリガーされないらしい
    },
    nameSelected(userID, userName) { //userIDを引数にしてuserRecordsから練習データを取得して並べる
      if (this.currentQuery != "") {
        this.currentQuery.off();
      }
      var thisNendo = dayjs().year();
      var thisMonth = dayjs().month();
      if (0 <= thisMonth && thisMonth <= 2) { //1,2,3月は年-1が年度
        thisNendo = thisNendo - 1;
      }
      this.nameList.forEach((item) => { //userが1年生のときはfieldsのデフォルトをコメントに
        if (item.name == userName && item.enterYear == thisNendo) {
          this.fields = [{
              key: "round",
              label: "回戦",
              thClass: "text-center",
              tdClass: "text-center records-round"
            },
            {
              key: "opponent",
              label: "対戦相手",
              thClass: "text-center",
              tdClass: "text-center records-name"
            },
            {
              key: "comment",
              label: "最新のコメント",
              thClass: "text-center",
              tdClass: "text-center"
            },
            {
              key: "detailButton",
              label: "",
              thClass: "text-center",
              tdClass: "text-center"
            }
          ]
          this.selectedFieldsValue = "komento";
        } else if (item.name == userName && item.enterYear != thisNendo) { //そうでないどきはデフォルトをまるばつに
          this.fields = [{
              key: "round",
              label: "回戦",
              thClass: "text-center",
              tdClass: "text-center records-round"
            },
            {
              key: "opponent",
              label: "対戦相手",
              thClass: "text-center",
              tdClass: "text-center records-name"
            },
            {
              key: "result",
              label: "勝敗",
              formatter: "numberToSymbol",
              thClass: "text-center",
              tdClass: "text-center records-result"
            },
            {
              key: "cardNumber",
              label: "枚数",
              thClass: "text-center",
              tdClass: "text-center records-cardNumber"
            },
            {
              key: "detailButton",
              label: "",
              thClass: "text-center",
              tdClass: "text-center"
            }
          ]
          this.selectedFieldsValue = "marubatsu";
        }
      });
      var dataQuery = this.database.ref("userRecords/" + userID);
      this.currentQuery = dataQuery;
      this.selectedName = userName;
      var _this = this; //foreach中でのthisはwindowではないっぽい
      dataQuery.on('value', function(snapshot) {
        _this.dataList = [];
        snapshot.forEach((dataByDay) => { //日付ごとのデータがkey:日付,value:データで入っている
          var hiduke = -dataByDay.key;
          var dataHash = {
            "date": hiduke
          }; //{"date":1234567890, "data":{うにょうにょ}}みたいになるはず
          var dataDetailArray = [];
          if (typeof(dataByDay.val()) === "object") { //dataByDay.val()は配列のときと連想配列の時がある…連想配列のとき
            Object.keys(dataByDay.val()).forEach((keyRound) => {
              var round = keyRound;
              var id = Object.keys(dataByDay.val()[keyRound])[0]; //for-inとどっちが早いでしょう？
              var detail = dataByDay.val()[keyRound][id];
              var detailHash = Object.assign({
                "round": round,
                "id": id
              }, detail); //detailHashは{"round":1,"id":"aiu","opponent":"qwe"...}みたいになるはず
              dataDetailArray.push(detailHash);
            });
          } else { //dataByDay.val()が配列の時。
            dataByDay.val().forEach((dataByRound, index) => { //roundごとのデータがkey:round,value:データで入っている
              var round = index;
              var id = Object.keys(dataByRound.val()[index])[0];
              var detail = dataByRound.val()[index][id];
              var detailHash = Object.assign({
                "round": round,
                "id": id
              }, detail); //detailHashは{"round":1,"id":"aiu","opponent":"qwe"...}みたいになるはず
              dataDetailArray.push(detailHash);
            });
          }
          dataHash["data"] = dataDetailArray;
          _this.dataList.push(dataHash);
        });
      });
      _this.dataAreaVisibility = true;
      // this.searchOnOff();
    },
    searchOnOff() {
      this.searchVisibility = !(this.searchVisibility);
    },
    searchOff() {
      this.searchVisibility = false;
    },
    async findFocusRecord(date, round, key) { //player1か2かとかややこしくてめんどいので記録を参照しにいきます
      var unixtime = -dayjs(date).unix();
      await this.database.ref("records/" + unixtime + '/' + round + '/' + key).once("value", snapshot => {
        this.focusRecord = snapshot.val();
      });
      this.$bvModal.show('edit');

    },
    test() {
      console.log("テスト");
      var testArray = ["全ての年度を", 2012, 2013];
      testArray = testArray.sort();
      console.log(testArray);
    },
    numberToSymbol(num) {
      if (num == "1") {
        return "○";
      } else if (num == "0") {
        return "×";
      } else {
        return "";
      }
    },
    suggestMemberList(input) { //inputに対応したかなでのサジェスト
      console.log(input);
      return this.memberNameList;
    },
    searchByName(name) { //呼ばれる頻度がめっちゃ高いのでnameListが大量になってきたらやばいかなあ
      for (let i = 0, l = this.nameList.length; i < l; i++) {
        if (name == this.nameList[i].name) {
          this.nameSelected(this.nameList[i].id, name);
        }
      }
    },
    fieldsChange(value) {
      if (value == "marubatsu") {
        this.fields = [{
            key: "round",
            label: "回戦",
            thClass: "text-center",
            tdClass: "text-center records-round"
          },
          {
            key: "opponent",
            label: "対戦相手",
            thClass: "text-center",
            tdClass: "text-center records-name"
          },
          {
            key: "result",
            label: "勝敗",
            formatter: "numberToSymbol",
            thClass: "text-center",
            tdClass: "text-center records-result"
          },
          {
            key: "cardNumber",
            label: "枚数",
            thClass: "text-center",
            tdClass: "text-center records-cardNumber"
          },
          {
            key: "detailButton",
            label: "",
            thClass: "text-center",
            tdClass: "text-center"
          }
        ]
      } else if (value == "shidou") {
        this.fields = [{
            key: "round",
            label: "回戦",
            thClass: "text-center",
            tdClass: "text-center records-round"
          },
          {
            key: "opponent",
            label: "対戦相手",
            thClass: "text-center",
            tdClass: "text-center records-name"
          },
          {
            key: "coaching",
            label: "指導内容",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "detailButton",
            label: "",
            thClass: "text-center",
            tdClass: "text-center"
          }
        ]
      } else if (value == "komento") {
        this.fields = [{
            key: "round",
            label: "回戦",
            thClass: "text-center",
            tdClass: "text-center records-round"
          },
          {
            key: "opponent",
            label: "対戦相手",
            thClass: "text-center",
            tdClass: "text-center records-name"
          },
          {
            key: "comment",
            label: "最新のコメント",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "detailButton",
            label: "",
            thClass: "text-center",
            tdClass: "text-center"
          }
        ]
      } else {
        console.log("なんやこのフィールドは" + value);
      }
    },
    createKagetoraURL() {
      this.KAGETORA_URL = this.KAGETORA_URL_BASE + this.selectedName
    },
    showKagetoraRecord() {
      const url = this.KAGETORA_URL;
      window.open(url, '_blank');
    }
  },
}
</script>
